import {
    adminLoggedIn, apiCallFailed, savedCustomer, retrievedCustomer, retrievedCustomers,
    retrievedLanguages, retrievedLanguage, savedLanguage, savedTranslationKeys, adminLogout, downloadedTranslations
} from "../redux/actions";
// TODO: DRY
class CustomerService {
    constructor(dispatch) {
        this.dispatch = dispatch;
        this.host = process.env.REACT_APP_CUSTOMER_SERVICE_HOST;
        this.checkAuth = this.checkAuth.bind(this);
    }

    checkAuth(response) {
        if(response.status === 401)
            this.dispatch(adminLogout(true));
        return response;
    }

    login(user, pass) {
        return fetch(this.host+"/api/v1/admin/login",{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify({username: user, password: pass})
        })
            .then(this.checkAuth)
            .then((response) => {
                switch(response.status) {
                    case 200:
                        response.json()
                            .then((data) => {
                                this.dispatch(adminLoggedIn(data));
                            })
                            .catch();
                        break;
                    default:
                        response.json()
                            .then((data) => {
                                this.dispatch(apiCallFailed(data));
                            })
                            .catch();
                }
            })
            .catch((err) => {
                this.dispatch(apiCallFailed(err));
            });
    }

    createCustomer(jwt, customer) {
        return fetch(this.host+"/api/v1/customers",{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "POST",
            body : JSON.stringify(customer)
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 201:
                    response.json()
                        .then(data => this.dispatch(savedCustomer(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    editCustomer(jwt, customer) {
        return fetch(this.host+"/api/v1/customers/"+customer.id,{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "PUT",
            body : JSON.stringify(customer)
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    response.json()
                        .then(data => this.dispatch(savedCustomer(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    getCustomer(jwt, id) {
        return fetch(this.host+"/api/v1/customers/"+id,{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "GET"
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    response.json()
                        .then(data => this.dispatch(retrievedCustomer(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    getCustomers(jwt) {
        return fetch(this.host+"/api/v1/customers",{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "GET"
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    response.json()
                        .then(data => this.dispatch(retrievedCustomers(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    createLanguage(jwt, language) {
        return fetch(this.host+"/api/v1/i18n",{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "POST",
            body : JSON.stringify(language)
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 201:
                    response.json()
                        .then(data => this.dispatch(savedLanguage(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    getLanguages(jwt) {
        return fetch(this.host+"/api/v1/i18n?flat=true",{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "GET"
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    response.json()
                        .then(data => this.dispatch(retrievedLanguages(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    getLanguage(jwt, id, flat = true) {
        return fetch(this.host+"/api/v1/i18n/"+id+"?flat="+flat+"&format=json",{
            headers: {
                'Authorization' : 'Bearer '+jwt
            },
            method: "GET"
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    return response.json()
                        .then(data => this.dispatch(retrievedLanguage(data)))
                        .catch();
                default:
                    return response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    downloadTranslations(jwt, id, flat = true, format = "json") {
        // TODO: Make this code pretty, at least it works.
        return fetch(this.host+"/api/v1/i18n/"+id+"?format=json",{          // Request meta data in JSON format so its readable
            headers: {
                'Authorization' : 'Bearer '+jwt
            },
            method: "GET"
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    return response.json().then(metaData => {
                        return fetch(this.host+"/api/v1/i18n/"+id+"/translations?flat="+flat+"&format="+format,{
                            headers: {
                                'Authorization' : 'Bearer '+jwt
                            },
                            method: "GET"
                        }).then(this.checkAuth).then((response) => {
                            switch(response.status) {
                                case 200:
                                    if(format === "json") {
                                        return response.json()
                                            .then(data => this.dispatch(downloadedTranslations(id, format, flat, data, metaData)))
                                            .catch();
                                    }
                                    else {
                                        return response.text()
                                            .then(data => this.dispatch(downloadedTranslations(id, format, flat, data, metaData)))
                                            .catch();
                                    }
                                default:
                                    return response.json()
                                        .then(data => this.dispatch(apiCallFailed(data)))
                                        .catch();
                            }
                        }).catch((err) => {
                            this.dispatch(apiCallFailed(err));
                        });
                    })
                    .catch();

                default:
                    return response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    editLanguage(jwt, language) {
        return fetch(this.host+"/api/v1/i18n/"+language.id,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "PUT",
            body : JSON.stringify(language)
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    response.json()
                        .then(data => this.dispatch(savedLanguage(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }

    updateTranslationKeys(jwt, id, translations) {
        return fetch(this.host+"/api/v1/i18n/"+id+"/translations?flat=true",{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer '+jwt
            },
            method: "PUT",
            body : JSON.stringify(translations)
        }).then(this.checkAuth).then((response) => {
            switch(response.status) {
                case 200:
                    response.json()
                        .then(data => this.dispatch(savedTranslationKeys(data)))
                        .catch();
                    break;
                default:
                    response.json()
                        .then(data => this.dispatch(apiCallFailed(data)))
                        .catch();
            }
        }).catch((err) => {
            this.dispatch(apiCallFailed(err));
        });
    }
}

export default CustomerService;


// WEBPACK FOOTER //
// ./src/services/CustomerService.js